import React from "react";
import { useTranslation } from "react-i18next";
import "./PinLegend.css";


export default function PinLegend() {

    const { t } = useTranslation(["nbhd"]);

    const yourPropText = t("nbhd.pins.your-prop");
    const viewedPropText = t("nbhd.pins.viewed-prop");
    const favPropText = t("nbhd.pins.fav-prop");
    const salePropText = t("nbhd.pins.sale-prop")
    const searchPropText = t("nbhd.pins.search-prop")
    return (
        <div className="neighbourhood-pins">
            <div className="content">
                <img src="images/Pins/blue_marker.png" alt={yourPropText} />
                <div>{yourPropText}</div>
            </div>
            <div className="content">
                <img src="images/Pins/yellow_marker.png" alt={viewedPropText} />
                <div>{viewedPropText}</div>
            </div>
            <div className="content">
                <img src="images/Pins/green_marker.png" alt={favPropText} />
                <div>{favPropText}</div>
            </div>
            <div className="content">
                <img src="images/Pins/purple_marker.png" alt={salePropText} />
                <div>{salePropText}</div>
            </div>
            <div className="content">
                <img src="images/Pins/orange_marker.png" alt={searchPropText} />
                <div>{searchPropText}</div>
            </div>
        </div>

    )
}